import { IonHeader, IonToolbar, useIonModal } from '@ionic/react';
import { useState } from 'react';
import { VersionPage } from '../pages/VersionPage';
import styles from './Header.module.css';
import { SiteIcon } from './SiteIcon';
interface HeaderType {
	left?: JSX.Element;
	title?: string | 'logo';
	right?: JSX.Element;
	testId?: string;
}
export const Header: React.FC<HeaderType> = ({ left, title, right, testId }) => {
	const [versionClicks, setVersionClicks] = useState(0);
	const [present, dismiss] = useIonModal(VersionPage, { onDismiss: () => dismiss() });
	const versionController = () => {
		if (versionClicks > 3) {
			setVersionClicks(0);
			present();
		} else {
			setVersionClicks(versionClicks + 1);
		}
	};
	return (
		<IonHeader>
			<IonToolbar>
				<div className={styles.headerContainer} data-testid={testId}>
					<div className={styles.left}>{left || <div />}</div>
					{title ? (
						title === 'logo' ? (
							<div className={styles.headerLogo} onClick={versionController}>
								<SiteIcon rounded={true} />
							</div>
						) : (
							<h5 className={styles.headerTitle}>{title}</h5>
						)
					) : null}

					<div className={styles.right}>{right || <div />}</div>
				</div>
			</IonToolbar>
		</IonHeader>
	);
};
